import { jsx as _jsx } from "react/jsx-runtime";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";
import { muiOutlinedInputRoot } from "../Input/input.config";
export const MuiAutocomplete = {
    defaultProps: {
        popupIcon: _jsx(ExpandMoreRoundedIcon, {})
    },
    styleOverrides: {
        root: {
            //By default, MUI Autocomplete applies redundant padding that affects our padding requirements.
            //To override this, we need to be more specific than just using the MuiOutlinedInput-root class.
            "& .MuiInputBase-root.MuiOutlinedInput-root": Object.assign(Object.assign({}, muiOutlinedInputRoot()), { 
                //This kicks in when an Autocomplete component contains a Chip
                "&.MuiInputBase-adornedStart": {
                    paddingTop: "9px",
                    paddingBottom: "9px",
                    paddingLeft: "16px",
                    gap: "4px",
                    "& .MuiOutlinedInput-input": {
                        padding: 0
                    },
                    "& .MuiChip-root": {
                        margin: "0"
                    }
                } }),
            "& .MuiAutocomplete-endAdornment": {
                top: "calc(50% - 15px)",
                "& .MuiIconButton-root": {
                    transition: "transform 0.3s ease"
                }
            }
        }
    }
};
//# sourceMappingURL=Autocomplete.js.map